// API URL must match your backend. Backend runs on PORT from newaz-backend .env (e.g. 5668 or 3000).
// Set REACT_APP_API_URL in .env to override (e.g. REACT_APP_API_URL=http://localhost:5668).
const apiUrl = process.env.REACT_APP_API_URL || "https://api.newazgyo.com";

export const config = {
  url: apiUrl,
  fronturl: apiUrl,
};
export const headersinfo = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': `multipart/form-data`,
}